import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import client from 'api/client';
import type {
    ProgramQuestionApplicable,
    ProgramQuestionForm,
    ProgramQuestionSaved,
    SaveProgramQuestionRequest,
} from 'types';

export interface ProgramQuestionQuery {
    country: string;
    programId?: string | null;
    userId?: number;
    form?: string | null;
}

function queryParams({ country, programId, userId, form }: ProgramQuestionQuery) {
    return {
        country,
        program_id: programId || undefined,
        user_id: userId,
        form: form || undefined,
    };
}

export function questions(
    params: ProgramQuestionQuery,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ProgramQuestionForm>> {
    return client.get<ProgramQuestionForm>('/program-questions/questions', {
        ...customConfig,
        params: queryParams(params),
    });
}

export function get(
    params: ProgramQuestionQuery,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ProgramQuestionSaved>> {
    return client.get<ProgramQuestionSaved>('/program-questions', {
        ...customConfig,
        params: queryParams(params),
    });
}

export function put(
    payload: SaveProgramQuestionRequest,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ProgramQuestionSaved>> {
    return client.put<ProgramQuestionSaved>('/program-questions', payload, customConfig);
}

export function applicable(
    userId?: number,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ProgramQuestionApplicable>> {
    return client.get<ProgramQuestionApplicable>('/program-questions/applicable', {
        ...customConfig,
        params: { user_id: userId },
    });
}
